export default function () {
    const vm = this;
    vm.selectedTemplateChanged = selectedTemplateChanged;

    function selectedTemplateChanged(template) {
        vm.template = template;
    }
}